import React from "react";
import { Repeat2 } from "lucide-react";
import { STAGE_COLORS, STATUS_COLORS, stageLabel, statusLabel } from "@/lib/constants";

// Repeat-enquiry badge: shows how many times this person re-enquired.
export const RepeatBadge = ({ count = 0, className = "" }) => {
  if (!count) return null;
  return (
    <span
      title={`Repeat enquiries: ${count}`}
      data-testid="repeat-badge"
      className={`inline-flex items-center gap-1 rounded-full bg-gold/15 px-1.5 py-0.5 text-[11px] font-semibold text-gold ${className}`}
    >
      <Repeat2 className="h-3 w-3" />
      {count}
    </span>
  );
};

// Stage = temperature (hot/warm/cold).
export const StageBadge = ({ stage, color }) => {
  const key = stage?.toLowerCase();
  return (
    <span
      data-testid={`stage-badge-${stage}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${color || STAGE_COLORS[key] || "bg-gray-100 text-gray-700"}`}
    >
      {stageLabel(stage)}
    </span>
  );
};

// Status = pipeline (New → Converted).
export const StatusBadge = ({ status, color }) => {
  const key = status?.toLowerCase();
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${color || STATUS_COLORS[key] || "bg-gray-100 text-gray-700"}`}
    >
      {statusLabel(status)}
    </span>
  );
};

